import { actions, selectors } from '@sloyd/store-base';
import { delay, put, select } from 'saga-ts';
import { $a } from 'shared-base';

export function* saveEnvironmentOnModel() {
  const model = yield* select(selectors.single.$currentModel);
  const holodeck = yield* select(selectors.raw.$rawHolodeckState);
  if (!model) return;

  yield put(actions.models.patch(model.id, { environment: holodeck }));
}

export function* loadEnvironmentFromModel(model: IModel) {
  if (!model) return;

  const environment = model.environment;

  if (!environment) {
    yield put(actions.holodeckStateForce.setAll({}));
    return;
  }

  yield put(actions.holodeckStateForce.setAll(environment));
  yield delay(100);

  yield put($a('HOLODECK', 'bootstrap', ''));
}
